import styled from 'styled-components';
import { HighlightedEntity } from '../../../HighlightingContext';
import { level1Content } from '../../../../styles/shareableStyles';

export const CohortRowContent = styled(HighlightedEntity)`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 16px;
  row-gap: 8px;
  min-height: 44px;
  padding: 12px 16px;
  ${level1Content};
`;

export const CohortRowRelatedInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
